/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Version } from '../../models/version';

export interface GetVersion$Params {
}

export function getVersion(http: HttpClient, rootUrl: string, params?: GetVersion$Params, context?: HttpContext): Observable<StrictHttpResponse<Version>> {
  const rb = new RequestBuilder(rootUrl, getVersion.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Version>;
    })
  );
}

getVersion.PATH = '/api/public/version';
